module.exports = __webpack_public_path__ + "img/marido.baner.16a4a8a7.png";